import script from "./DonateActivity.vue?vue&type=script&lang=ts&setup=true"
export * from "./DonateActivity.vue?vue&type=script&lang=ts&setup=true"

import "./DonateActivity.vue?vue&type=style&index=0&id=19a07023&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a07023"]])

export default __exports__